import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicTicketSectionsApi extends BaseModulePublicApi {
  basePath = 'tickets_sections';
};
